import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Alerta from "../../components/alerta/Alerta";
import Loader from "../../components/loader/Loader";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./AvaliacaoEspecifica.module.css";
import { Form } from "react-bootstrap";
import GraficoRadar from "../../components/graficoRadar/GraficoRadar";
import { Link } from "react-router-dom";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
function AvaliacaoNovo() {

    const location = useLocation();
    const [avaliacaoId, setAvaliacaoId] = useState(() => {
        return location.state || localStorage.getItem("avaliacaoId") || null;
    });
            
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");
    const [loading, setLoading] = useState(false);
    const [visibilidadeDescricao, setVisibilidadeDescricao] = useState({});
    const [avaliacaoCompleta, setAvaliacaoCompleta] = useState(null);
  
    const [avaliacaoEnum, setAvaliacaoEnum] = useState(null);


    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);


    const AlternarVisibilidade = (criterioId) => {
        setVisibilidadeDescricao((prevState) => ({
            ...prevState,
            [criterioId]: !prevState[criterioId],
        }));
    };

    async function ObterAvaliacaoCompleta() {
        try {
            setLoading(true);
            const listaCompleta = await AvaliacaoApi.ObterAvaliacaoCompleta(avaliacaoId);

            setAvaliacaoCompleta(listaCompleta);
        } catch (error) {
            console.error("Erro ao obter avaliação");
        } finally {
            setLoading(false);
        }
    }

    async function ListarEnumCriterios() {
        setLoading(true);
        try {
            const listaEnum = await AvaliacaoApi.ListarEnumAvaliacao();
            setAvaliacaoEnum(listaEnum);
        } catch (error) {
            setMensagemAlerta("Erro ao listar critérios.");
            setTipoAlerta("erro");
            setMostrarAlerta(true);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {

        if (avaliacaoId) {
            localStorage.setItem("avaliacaoId", avaliacaoId);
        }

        ListarEnumCriterios();
        ObterAvaliacaoCompleta();
    }, [avaliacaoId]);

    useEffect(() => {
        return () => {
            localStorage.removeItem("avaliacaoId");
        };
    }, []);


    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar
                menuHamburguerAberto={menuHamburguerAberto}
                setMenuHamburguerAberto={setMenuHamburguerAberto}
            >
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}

                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h4>Avaliação de {new Date(avaliacaoCompleta?.dataRealizada).toLocaleDateString("pt-BR")}</h4>
                    </div>

                    <Form className={style.criterios_graficos}>
                        <div className={style.container_criterios}>
                            {avaliacaoCompleta?.criterios.map((criterio) => {
                                const pontoSelecionado = criterio.pontosCriterios[0]; // sempre pegando o primeiro, pois vem assim no JSON

                                return (
                                    <div key={criterio.criterioID} className={style.container_criterio}>
                                        <div className={style.input_select_container}>
                                            {/* Botão toggle da descrição */}
                                            {pontoSelecionado?.nota && (
                                                <Link
                                                    onClick={() => AlternarVisibilidade(criterio.criterioID)}
                                                    id={style.botao_toggle}
                                                >
                                                    {visibilidadeDescricao[criterio.criterioID] ? <AiOutlineUp /> : <AiOutlineDown />}
                                                </Link>
                                            )}

                                            <Form.Label id={style.form_label}>{criterio.nomeCriterio}</Form.Label>

                                            <Form.Group controlId={`dropdown-${criterio.criterioID}`} className="col">

                                                <option value={pontoSelecionado.nota}>
                                                    {avaliacaoEnum?.find((x) => x.id === pontoSelecionado.nota)?.nome || pontoSelecionado.nota}

                                                </option>

                                            </Form.Group>
                                        </div>

                                        {/* Exibição da descrição */}
                                        {visibilidadeDescricao[criterio.criterioID] && pontoSelecionado?.descricaoPonto && (
                                            <p className={style.descricao}>
                                                {pontoSelecionado.descricaoPonto}
                                            </p>
                                        )}
                                    </div>
                                );
                            })}

                            <Form.Group>
                                <Form.Label>Pontos Positivos</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Pontos Positivos"
                                    name="pontosPositivos"
                                    value={avaliacaoCompleta?.pontosPositivos || ""}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Pontos De Evolução</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Pontos De Evolução"
                                    name="pontosEvolucao"
                                    value={avaliacaoCompleta?.pontosEvolucao || ""}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Direcionadores</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    placeholder="Direcionadores"
                                    name="direcionadores"
                                    value={avaliacaoCompleta?.direcionadores || ""}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                        </div>
                        <div className={style.grafico_radar}>
                            <GraficoRadar
                                labels={avaliacaoCompleta?.criterios.map((criterio) => criterio.nomeCriterio) || []}
                                data={avaliacaoCompleta?.criterios.map(
                                    (criterio) => criterio.pontosCriterios[0]?.nota || 0
                                ) || []}
                            />
                        </div>
                    </Form>
                </div>
            </Topbar>
        </Sidebar>
    );
}

export default AvaliacaoNovo;
